// import './utils/analyticsInit'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { supabase } from './config/supabase'
import { SupabaseAuthProvider } from './contexts/SupabaseAuthContext'
import './styles/index.css'
import './utils/testProductionUpload'

// Expor Supabase globalmente para debug/scripts
;(window as any).supabase = supabase

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SupabaseAuthProvider>
        <App />
      </SupabaseAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
